import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TPurchasingCodeDto } from '../../interfaces/tpurchasing-code.model';
import { apiEndpoints } from '../../constants/api-endpoints';
import { HttpUtilityService } from '../http.utility.service';

@Injectable({ providedIn: 'root' })
export class PurchasingCodeService {
  constructor(private readonly httpUtilityService: HttpUtilityService) {}

  add(dto: TPurchasingCodeDto): Observable<HttpResponse<TPurchasingCodeDto>> {
    return this.httpUtilityService.post<TPurchasingCodeDto>(
      apiEndpoints.purchasingCodeList,
      dto
    );
  }

  delete(id: number): Observable<HttpResponse<void>> {
    return this.httpUtilityService.delete(
      apiEndpoints.purchasingCodeList,
      id.toString()
    );
  }

  update(dto: TPurchasingCodeDto) {
    const url = `${apiEndpoints.purchasingCodeList}/${dto.purchasingId}`;
    return this.httpUtilityService.put(url, dto);
  }
}
